var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.jiaoBiao.text && _vm.jiaoBiao.bgColor)?_c('span',{staticClass:"eatingTag",class:[_vm.jiaoBiao.bgColor]},[_vm._v(" "+_vm._s(_vm.jiaoBiao.text)+" "),_c('img',{staticClass:"eatingTail",attrs:{"src":require("../../assets/img/left.png")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }